<template>
  <div class="list-hread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item>{{this.firstTitle}}</el-breadcrumb-item> -->
        <!-- <el-breadcrumb-item v-for="(item,index) in current" :key="index" v-if="current">{{item.categoryName}}</el-breadcrumb-item> -->
        <el-breadcrumb-item  v-if="current">{{current.categoryName}}</el-breadcrumb-item>
      </el-breadcrumb>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "bread",
  props: ["firstTitle"],
  data() {
    return {
      breadData: null,
    };
  },
  computed: {
    //获取vuex current数据
    ...mapState({
      current: (state) => state.currentMenu,
    }),

  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.list-hread {
    height: 50px;
    line-height: 50px;
    padding: 0 30px;
    background: #fde5ce;
    display: flex;
    align-items: center;
    .el-breadcrumb  /deep/  .el-breadcrumb__inner 
      {
        color: #f77f11;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/helpCenter/breadcrumb.vue